import { params } from "../../vars/params";
import { config } from "../../../config";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(SplitText);
gsap.registerPlugin(ScrollTrigger);

export const scrollIn = (): void => {
  const triggers = document.querySelectorAll("[data-anim-trigger]");
  const anims = document.querySelectorAll("[data-anim]");
  const titles = document.querySelectorAll("[data-anim-title]");
  const zooms = document.querySelectorAll("[data-zoom]");
  const fades = document.querySelectorAll("[data-fade]");
  const wipes = document.querySelectorAll("[data-wipe]");
  const typeIns = document.querySelectorAll("[data-type-in]");
  const cards = document.querySelectorAll("[data-card]");
  const scrollClasses = document.querySelectorAll("[data-scroll-class]");
  const ctas = document.querySelectorAll(".c-cta");
  const isSp = window.innerWidth < config.breakPoint;
  const endStart = isSp ? "top 120px" : "bottom 40%";
  const endEnd = isSp ? "top 60px" : "bottom 20%";
  triggers.forEach((trigger) => {
    const staggers = trigger.querySelectorAll("[data-stagger]");
    gsap.to(staggers, {
      opacity: 1,
      y: 0,
      duration: 0.4,
      stagger: 0.15,
      scrollTrigger: {
        trigger: trigger,
        start: `top ${params.isSp ? config.triggerPos.sp : config.triggerPos.pc}`,
        toggleClass: { targets: staggers, className: "--scrolled" },
        toggleActions: "play none none reverse",
      },
    });
  });
  anims.forEach((anim) => {
    gsap.to(anim, {
      opacity: 1,
      y: 0,
      duration: 0.4,
      stagger: 0.1,
      scrollTrigger: {
        trigger: anim,
        start: `top ${params.isSp ? config.triggerPos.sp : config.triggerPos.pc}`,
        toggleActions: "play none none reverse",
      },
    });
  });
  // titles.forEach((title) => {
  //   const en = title.querySelector(".c-ttl-sec__inner") as HTMLElement;
  //   const ja = title.querySelector(".c-ttl-sec__ja") as HTMLElement;
  //   const tl = gsap.timeline({
  //     scrollTrigger: {
  //       trigger: title,
  //       start: `top ${params.isSp ? config.triggerPos.sp : config.triggerPos.pc}`,
  //       toggleActions: "play none none reverse",
  //     },
  //   });
  //   tl.to(en, {
  //     opacity: 1,
  //     duration: 1.5,
  //   });
  //   tl.to(
  //     ja,
  //     {
  //       opacity: 1,
  //       duration: 0.5,
  //     },
  //     "<0.4"
  //   );
  // });
  wipes.forEach((wipe) => {
    const wipeElm = wipe as HTMLElement;
    const wipeType = wipeElm.dataset.wipe;
    const wipeDuration = parseFloat(wipeElm.dataset.duration || "0.8");
    const wipeDelay = parseFloat(wipeElm.dataset.delay || "0");
    if (wipeType === "r-l") {
      gsap.fromTo(
        wipeElm,
        {
          clipPath: "inset(0 0 0 100%)",
        },
        {
          clipPath: "inset(0 0 0 0%)",
          duration: wipeDuration,
          delay: wipeDelay,
          ease: "power3.out",
          scrollTrigger: {
            trigger: wipeElm,
            start: "top 80%",
            toggleActions: "play none none reverse",
          },
        }
      );
    }
    if (wipeType === "l-r") {
      gsap.fromTo(
        wipeElm,
        {
          clipPath: "inset(0 100% 0 0)",
        },
        {
          clipPath: "inset(0 0% 0 0)",
          duration: wipeDuration,
          delay: wipeDelay,
          ease: "power3.out",
          scrollTrigger: {
            trigger: wipeElm,
            start: "top 80%",
            toggleActions: "play none none reverse",
          },
        }
      );
    }
    if (wipeType === "t-b") {
      gsap.fromTo(
        wipeElm,
        {
          clipPath: "inset(0 0 100% 0)",
        },
        {
          clipPath: "inset(0 0 0% 0)",
          duration: wipeDuration,
          delay: wipeDelay,
          ease: "power3.out",
          scrollTrigger: {
            trigger: wipeElm,
            start: "top 80%",
            toggleActions: "play none none reverse",
          },
        }
      );
    }
    if (wipeType === "b-t") {
      gsap.fromTo(
        wipeElm,
        {
          clipPath: "inset(100% 0 0 0)",
        },
        {
          clipPath: "inset(0% 0 0 0)",
          duration: wipeDuration,
          delay: wipeDelay,
          ease: "power3.out",
          scrollTrigger: {
            trigger: wipeElm,
            start: "top 80%",
            toggleActions: "play none none reverse",
          },
        }
      );
    }
  });
  zooms.forEach((zoom) => {
    const zoomElm = zoom as HTMLElement;
    const zoomType = zoomElm.dataset.zoom;
    if (zoomType === "in-out" || zoomType === "in") {
      const startTl = gsap.timeline({
        scrollTrigger: {
          trigger: zoomElm,
          start: "top 90%",
          end: "top 80%",
          scrub: true,
        },
      });
      startTl
        .to(zoomElm, {
          opacity: 1,
          duration: 1,
        })
        .fromTo(
          zoomElm,
          {
            scale: 0.5,
          },
          {
            scale: 1,
            ease: "power2.out",
            duration: 2,
          },
          0
        );
    }
    if (zoomType === "in-out" || zoomType === "out") {
      const endTl = gsap.timeline({
        scrollTrigger: {
          trigger: zoomElm,
          start: endStart,
          end: endEnd,
          scrub: true,
        },
      });
      endTl
        .to(
          zoomElm,
          {
            opacity: 0,
            duration: 1,
          },
          1
        )
        .fromTo(
          zoomElm,
          {
            scale: 1,
          },
          {
            scale: 0.5,
            ease: "power2.in",
            duration: 2,
          },
          0
        );
    }
  });
  fades.forEach((fade) => {
    const fadeElm = fade as HTMLElement;
    const fadeType = fadeElm.dataset.fade;
    const fadeTrigger = parseFloat(fadeElm.dataset.fadeTrigger || "0");
    const fadeDelay = parseFloat(fadeElm.dataset.delay || "0");
    const fadeDuration = parseFloat(fadeElm.dataset.duration || "0.5");
    const fadeBlur = parseFloat(fadeElm.dataset.blur || "0");
    const fadeDist = parseFloat(fadeElm.dataset.dist || "0");
    const fadeAnchor = fadeElm.dataset.anchor || fadeElm;
    if (fadeType === "in") {
      gsap.set(fadeElm, { filter: `blur(${fadeBlur}px)` });
      gsap.to(fadeElm, {
        opacity: 1,
        y: 0,
        filter: "blur(0px)",
        duration: fadeDuration,
        delay: fadeDelay,
        scrollTrigger: {
          trigger: fadeAnchor,
          start: `top ${80 + fadeTrigger}%`,
          toggleActions: "play none none reverse",
        },
      });
    }
    if (fadeType === "in-up") {
      gsap.set(fadeElm, { filter: `blur(${fadeBlur}px)`, y: `${fadeDist}%` });
      gsap.to(fadeElm, {
        opacity: 1,
        y: 0,
        filter: "blur(0px)",
        duration: fadeDuration,
        delay: fadeDelay,
        scrollTrigger: {
          trigger: fadeAnchor,
          start: `top ${80 + fadeTrigger}%`,
          toggleActions: "play none none reverse",
        },
      });
    }
    if (fadeType === "in-down") {
      gsap.set(fadeElm, { y: `-${fadeDist}%`, opacity: 0 });
      gsap.to(fadeElm, {
        opacity: 1,
        y: "0%",
        filter: "blur(0px)",
        duration: fadeDuration,
        delay: fadeDelay,
        scrollTrigger: {
          trigger: fadeAnchor,
          start: `top ${80 + fadeTrigger}%`,
          toggleActions: "play none none reverse",
        },
      });
    }
    if (fadeType === "in-left") {
      gsap.set(fadeElm, { filter: `blur(${fadeBlur}px)`, x: `-${fadeDist}%`, opacity: 0 });
      gsap.to(fadeElm, {
        opacity: 1,
        x: "0%",
        filter: "blur(0px)",
        duration: fadeDuration,
        delay: fadeDelay,
        scrollTrigger: {
          trigger: fadeAnchor,
          start: `top ${80 + fadeTrigger}%`,
          toggleActions: "play none none reverse",
        },
      });
    }
    if (fadeType === "in-right") {
      gsap.set(fadeElm, { filter: `blur(${fadeBlur}px)`, x: `${fadeDist}%`, opacity: 0 });
      gsap.to(fadeElm, {
        opacity: 1,
        x: "0%",
        filter: "blur(0px)",
        duration: fadeDuration,
        delay: fadeDelay,
        scrollTrigger: {
          trigger: fadeAnchor,
          start: `top ${80 + fadeTrigger}%`,
          toggleActions: "play none none reverse",
        },
      });
    }
  });
  cards.forEach((card) => {
    const cardElm = card as HTMLElement;
    const cardType = cardElm.dataset.card;
    const cardStagger = parseFloat(cardElm.dataset.cardStagger || "0.2");
    const cardDuration = parseFloat(cardElm.dataset.cardDuration || "0.25");
    const cardItems = cardElm.querySelectorAll("[data-card-item]");
    const cardStart = cardElm.dataset.cardStart || "top 90%";
    const cardDelay = parseFloat(cardElm.dataset.delay || "0");
    const cardOffsetY = parseFloat(cardElm.dataset.offsetY || "10");
    cardItems.forEach((item, index) => {
      const startTl = gsap.timeline({
        ease: "none",
        delay: cardDelay,
        scrollTrigger: {
          trigger: cardElm,
          start: cardStart,
          toggleActions: "play none none reverse",
          toggleClass: { targets: item, className: "--scrolled" },
          // scrub: true,
        },
      });
      startTl.fromTo(
        item,
        {
          // scale: 0.7,
          y: cardOffsetY + "%",
          opacity: 0,
          filter: "blur(5px)",
        },
        {
          // scale: 1,
          y: 0,
          opacity: 1,
          filter: "blur(0px)",
          ease: "power1.out",
          duration: cardDuration,
          delay: index * cardStagger,
        }
      );
    });
  });
  scrollClasses.forEach((scrollClass) => {
    const scrollClassElm = scrollClass as HTMLElement;
    const className = scrollClassElm.dataset.scrollClass || "is-scrolled";
    if (!className) return;
    const start = scrollClassElm.dataset.start || "top 80%";
    ScrollTrigger.create({
      trigger: scrollClassElm,
      start: start,
      toggleClass: { targets: scrollClassElm, className: className },
    });
  });
  typeIns.forEach((typeIn) => {
    const typeInElm = typeIn as HTMLElement;
    const splitText = new SplitText(typeIn, { types: "chars", tag: "span", charsClass: "c-anim-char" });
    const delay = parseFloat(typeInElm.dataset.delay || "0");
    const duration = parseFloat(typeInElm.dataset.duration || "0.001");
    const stagger = parseFloat(typeInElm.dataset.stagger || "0.05");
    const offsetY = parseFloat(typeInElm.dataset.offsetY || "0") * 100;
    const tl = gsap.timeline({
      delay: delay,
      scrollTrigger: {
        trigger: typeInElm,
        start: "top 90%",
        // end: "top 80%",
        // scrub: true,
      },
    });
    tl.from(splitText.chars, {
      opacity: 0,
      duration: duration,
      stagger: stagger,
      y: offsetY + "%",
    });
  });
  ctas.forEach((cta) => {
    const ctaElm = cta as HTMLElement;
    const origAngle = 122;
    const delta = 200;
    gsap.fromTo(
      ctaElm,
      {
        background: `linear-gradient(${origAngle - delta}deg, #1bb7a5 15%, #f000c6 90%)`,
        scale: 0.8,
      },
      {
        background: `linear-gradient(${origAngle + delta}deg, #1bb7a5 15%, #f000c6 90%)`,
        scale: 1,
        duration: 2,
        ease: "none",
        scrollTrigger: {
          trigger: ctaElm,
          start: "top 100%",
          end: "center 50%",
          scrub: true,
        },
      }
    );
  });
  const secTtls = document.querySelectorAll(".c-ttl-sec:not(.--anim-none)");
  if (secTtls.length > 0) {
    secTtls.forEach((secTtl) => {
      const secTtlElm = secTtl as HTMLElement;
      const sub = secTtlElm.querySelector(".c-ttl-sec__sub") as HTMLElement;
      const main = secTtlElm.querySelector(".c-ttl-sec__main") as HTMLElement;
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: secTtlElm,
          start: `top ${params.isSp ? config.triggerPos.sp : config.triggerPos.pc}`,
          toggleActions: "play none none reverse",
        },
      });
      tl.fromTo(
        sub,
        {
          opacity: 0,
          // y: 20,
          filter: "blur(10px)",
        },
        {
          opacity: 1,
          // y: 0,
          duration: 0.5,
          filter: "blur(0px)",
        }
      );
      tl.fromTo(
        main,
        {
          opacity: 0,
          // y: 20,
          filter: "blur(10px)",
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.5,
          filter: "blur(0px)",
        },
        0.2
      );
    });
  }
  const kakeruSection = document.querySelector(".p-about-kakeru");
  if (kakeruSection) {
    const kakeruSectionElm = kakeruSection as HTMLElement;
    const kakeruSectionItem1 = kakeruSectionElm.querySelector(".p-about-kakeru__item:nth-child(1)") as HTMLElement;
    const kakeruSectionItem2 = kakeruSectionElm.querySelector(".p-about-kakeru__item:nth-child(3)") as HTMLElement;
    const kakeruSectionCross1 = kakeruSectionElm.querySelector(".p-about-kakeru__kakeru .--line:nth-child(1)") as HTMLElement;
    const kakeruSectionCross2 = kakeruSectionElm.querySelector(".p-about-kakeru__kakeru .--line:nth-child(2)") as HTMLElement;

    const kakeruSectionTl = gsap.timeline({
      scrollTrigger: {
        trigger: kakeruSectionElm,
        start: isSp ? `top 90%` : `center 90%`,
        end: isSp ? `bottom 110%` : `center 55%`,
        scrub: true,
      },
    });
    kakeruSectionTl.fromTo(
      kakeruSectionItem1,
      {
        opacity: 0,
        filter: "blur(20px)",
        y: "10%",
      },
      {
        filter: "blur(0px)",
        y: 0,
        opacity: 1,
        duration: 1,
      },
      0
    );
    kakeruSectionTl.fromTo(
      kakeruSectionItem2,
      {
        opacity: 0,
        filter: "blur(20px)",
        y: "10%",
      },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        filter: "blur(0px)",
      },
      isSp ? 2.5 : 0.3
    );
    kakeruSectionTl.fromTo(
      kakeruSectionCross1,
      {
        clipPath: "inset(-10px 100% -10px 0)",
      },
      {
        clipPath: "inset(-10px 0% -10px 0)",
        duration: 1,
      },
      isSp ? 1.8 : 0.8
    );
    kakeruSectionTl.fromTo(
      kakeruSectionCross2,
      {
        clipPath: "inset(-10px 0% -10px 100%)",
      },
      {
        clipPath: "inset(-10px 0 -10px 0%)",
        duration: 1,
      },
      isSp ? 2 : 1
    );
  }
};
